
import React from "react";

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
  const getPasswordStrength = (password: string): { score: number; feedback: string[] } => {
    const feedback: string[] = [];
    let score = 0;

    if (password.length >= 12) score += 1;
    else feedback.push("Use at least 12 characters");

    if (/[A-Z]/.test(password)) score += 1;
    else feedback.push("Include uppercase letters");

    if (/[a-z]/.test(password)) score += 1;
    else feedback.push("Include lowercase letters");

    if (/[0-9]/.test(password)) score += 1;
    else feedback.push("Include numbers");

    if (/[^A-Za-z0-9]/.test(password)) score += 1;
    else feedback.push("Include special characters");

    if (!/(.)\1{2,}/.test(password)) score += 1;
    else feedback.push("Avoid repeated characters");

    return { score, feedback };
  };

  const passwordStrength = password ? getPasswordStrength(password) : null;

  if (!passwordStrength || !password) return null;

  return (
    <div className="space-y-2">
      <div className="flex space-x-1">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`h-2 w-full rounded ${
              i < passwordStrength.score
                ? passwordStrength.score < 3
                  ? "bg-red-500"
                  : passwordStrength.score < 5
                  ? "bg-yellow-500"
                  : "bg-green-500"
                : "bg-gray-200"
            }`}
          />
        ))}
      </div>
      {passwordStrength.feedback.length > 0 && (
        <ul className="text-sm text-gray-600 space-y-1">
          {passwordStrength.feedback.map((item, i) => (
            <li key={i} className="flex items-center space-x-2">
              <span className="text-red-500">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
